"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _address = require("@/api/address");
var state = {
  cities: [],
  districts: []
};
var mutations = {
  setCities: function setCities(state, val) {
    state.cities = val;
  },
  setDistricts: function setDistricts(state, val) {
    state.districts = val;
  }
};
var actions = {
  fetchCities: function fetchCities(_ref, payload) {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var commit, res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return _address.addressApi.findCity();
          case 3:
            res = _context.sent;
            commit("setCities", res.data.data);
            return _context.abrupt("return", {
              total: res.data.total,
              data: res.data.data
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  fetchDistricts: function fetchDistricts(_ref2, payload) {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
      var commit, res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 3;
            return _address.addressApi.findDistrict(payload);
          case 3:
            res = _context2.sent;
            commit("setDistricts", res.data.data);
            return _context2.abrupt("return", {
              total: res.data.total,
              data: res.data.data
            });
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};